/* Shared, side-effect-free commerce rules. Amounts are integer currency subunits. */
(function(root){
  'use strict';
  const tiers=[15,30,45,60];
  function cadence(a){
    const text=[a.name,...(a.options||[]).map(o=>o.value)].join(' ');
    const match=text.match(/\b(\d+)\s*[- ]?\s*days?\b/i);
    return match?Number(match[1]):null;
  }
  function validPlan(a,servings){
    return !!(a&&String(a.id)===String(a.mapped_plan_id)&&a.recurring===true&&
      Number.isInteger(a.price)&&a.price>0&&cadence(a)===servings&&
      Array.isArray(a.price_adjustments)&&a.price_adjustments.length>0&&
      a.price_adjustments.every(x=>Number.isInteger(x.price)&&x.price>0));
  }
  function offers(data,mode){
    return tiers.map(servings=>{
      const candidates=(data.variants||[]).filter(v=>Number(v.servings)===servings&&(mode==='once'?v.one_time===true:servings>15&&!v.one_time));
      // Multiple mappings are ambiguous: never choose an arbitrary variant.
      if(candidates.length!==1)return {servings,valid:false,available:false,reason:candidates.length?'More than one product is mapped to this supply.':'Shopify product mapping is missing.'};
      const v=candidates[0];
      const allocations=mode==='subscribe'?(v.allocations||[]).map(a=>({...a,mapped_plan_id:v.mapped_plan_id})).filter(a=>validPlan(a,servings)):[];
      const valid=!!v.id&&Number.isInteger(v.price)&&v.price>0&&(mode==='subscribe'?allocations.length===1:!v.requires_plan);
      const price=valid?(mode==='subscribe'?allocations[0].price:v.price):null;
      const allocation=allocations[0];
      const renewal=allocation?.price_adjustments.at(-1)?.price;
      if(allocation)allocation.terms={renewal_price:renewal,billing:`Every ${servings} days`,delivery:`Every ${servings} days`};
      const reason=!v.id?'Variant ID does not match the selected Shopify product.':mode==='subscribe'&&!allocations.length?'Selling plan is missing, unavailable, or has a different delivery interval.':!valid?'This Shopify purchase option is unavailable.':!v.available?'Sold out.':'';
      return {servings,variant:v,allocations,valid,available:valid&&v.available,price,reason};
    });
  }
  function supplies(data,preferred='subscribe'){
    const once=offers(data,'once'), subscriptions=offers(data,'subscribe');
    return once.map((o,i)=>{
      const sub=subscriptions[i], options={once:o,subscribe:sub};
      const chosen=options[preferred].available?options[preferred]:o.available?o:sub.available?sub:o.valid?o:sub.valid?sub:o;
      return {...chosen,modes:Object.keys(options).filter(mode=>options[mode].available)};
    });
  }
  function presentation(choices){
    const comparable=choices.filter(o=>o.valid&&o.available&&Number.isFinite(o.price)&&o.servings>0);
    const lowest=comparable.length>1?Math.min(...comparable.map(o=>o.price/o.servings)):null;
    return choices.map(o=>({...o,recommended:!!(o.valid&&o.available&&o.servings===45),lowest:!!(o.valid&&o.available&&lowest!==null&&o.price/o.servings===lowest)}));
  }
  function savingsBasis(data,price,servings){
    const baseline=offers(data,'once').find(o=>o.servings===15&&o.valid&&o.available);
    if(!baseline||!Number.isFinite(price)||servings<=15)return null;
    const total=baseline.price*servings/15;
    return price<total?{total,percent:Math.round((1-price/total)*100)}:null;
  }
  function cartItem(offer,mode,plan){
    if(!offer?.available||!offer.variant?.id)return null;
    if(offer.standalone)return mode==='once'?{id:offer.variant.id,quantity:1}:null;
    const item={id:offer.variant.id,quantity:1,properties:{Supply:`${offer.servings} servings`,Contents:offer.variant.contents||''}};
    if(mode==='subscribe'){
      if(!(offer.allocations||[]).some(a=>String(a.id)===String(plan?.id)))return null;
      item.selling_plan=plan.id;
    }
    return item;
  }
  function shipping(subtotal,currency,rule){
    const countries=String(rule?.countries||'').split(',').map(x=>x.trim().toUpperCase()).filter(Boolean);
    if(!rule?.verified||currency!==rule.currency||!countries.includes(rule.country)||!Number.isInteger(rule.minimum)||rule.minimum<1)return {eligible:false};
    const remaining=Math.max(0,rule.minimum-Number(subtotal));
    return {eligible:true,remaining,attained:remaining===0,progress:Math.min(100,Math.max(0,subtotal/rule.minimum*100)),threshold:rule.minimum-1};
  }
  const api={cadence,validPlan,offers,supplies,presentation,savingsBasis,cartItem,shipping};
  if(typeof module!=='undefined'&&module.exports)module.exports=api;
  else root.PTCommerce=api;
})(globalThis);
